import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchOrderHubOrderLines } from '@/api/order-hub';
import { buildOrderLinesQs } from '../-utils/listParams';
import { ordersHubKeys } from './useOrdersHubList';

export function orderHubOrderLinesQueryOptions(orderId: string) {
  return queryOptions({
    queryKey: ordersHubKeys.lines(orderId),
    queryFn: () => fetchOrderHubOrderLines(buildOrderLinesQs(orderId)),
    staleTime: 5 * 60_000,
  });
}

export function useOrderHubOrderLinesList(orderId: string) {
  return useQuery({
    ...orderHubOrderLinesQueryOptions(orderId),
    enabled: !!orderId,
    select: res => res.data,
  });
}
